import {ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {CookieService} from "ngx-cookie";
import {AiBuilderService} from "../../../../../../../websites/website/ai-builder/service/ai-builder.service";
import {NotifierComponent} from "../../../../../../../shared/components/notifier/notifier.component";
import {ActivatedRoute, Router} from "@angular/router";
import {IDsDropdownOption} from "../../../../../../../shared/components/ds-dropdown/ds-dropdown-option";
import {NotificationType} from "../../../../../../../shared/components/notifier/notification-type";
import {DbResponse} from "../../../../../../../shared/interceptors/db-response";
import {Subscription} from "rxjs";
import {Notification} from "../../../../../../../shared/components/notifier/notification";
import {filter, first} from "rxjs/operators";
import {AiAssistantService} from "../../../../../../../ai-assistant/service/ai-assistant.service";

@Component({
    selector: 'db-create-ai-assistant-store-type',
    templateUrl: './create-ai-assistant-store-type.component.html',
    styleUrls: ['./create-ai-assistant-store-type.component.scss'],
    standalone: false
})
export class CreateAiAssistantStoreTypeComponent implements OnInit {
  @Input() selectedStoreType = null;
  @Input() selectedBusinessCategory = null;
  @Input() isFirstStep: boolean = false;
  @Input() isOnboarding: boolean = false;
  @Input() hideBackButton: boolean = false;
  @Input() storeTypes;

  @Output() back = new EventEmitter<void>();
  @Output() storeTypeSelected = new EventEmitter<{ type: string; group: string }>();
  @Output() categoryType = new EventEmitter<string>();


  public fromStartAIPage: boolean = false;
  public storeTypesForView: any;
  public fromDomains: any;

  private _categoriesRequestSubscription: Subscription;
  private _filteredCategories = [];


  constructor(
    private readonly router: Router,
    private readonly _route: ActivatedRoute,
    private readonly _cookieService: CookieService,
    private readonly _builderService: AiBuilderService,
    private _aiAssistantService: AiAssistantService,
    private _cdr: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.fromDomains = localStorage.getItem('dbOnboardingDomainName');
    this._filteredCategories = this.storeTypes;
    if (!this.storeTypes) {
      this._aiAssistantService.getCategories(true)
        .pipe(
          first(response => !!response),
        )
        .subscribe(response => {
          if (response.success) {
            this.storeTypes = response.data.map(({name, title, keywords, type}) => (
              {label: title, value: title, keywords, type}
            ));
            this._filteredCategories = this.storeTypes;
            this.storeTypesForView = this.storeTypes;
          }
        });
    } else {
      this.storeTypesForView = this.storeTypes;
    }

    this.fromStartAIPage = window.location.href.indexOf("start-ai-website-building") > -1;
  }


  public selectStoreType(option: { value: IDsDropdownOption['value'], group: IDsDropdownOption['group'] }) {
    this.selectedStoreType = option?.value as string;
    this.selectedBusinessCategory = option?.group as string;
  }

  public searchCategory($event) {
    if (this._categoriesRequestSubscription) {
      this._categoriesRequestSubscription.unsubscribe();
      this._categoriesRequestSubscription = null;
    }
    if ($event === '') {
      this._filteredCategories = this.storeTypes;
      return this.storeTypesForView = this.storeTypes;
    }
    this._categoriesRequestSubscription = this._builderService.searchCategories($event, true)
      .pipe(filter((response: DbResponse): boolean => !!response),
      first())
      .subscribe((response: DbResponse): void => {
        if (response.success) {
          this._filteredCategories = response.data;
          const searchedResult = response.data.map((storeType) => (
            {
              label: storeType.title,
              highlightedLabel: storeType.title.replace(new RegExp($event, "gi"), (match) => `<span class="ds-highlighted">${match}</span>`),
              value: storeType.title,
              group: storeType.group
            }));
          const combinedArray = [...searchedResult, ...this.storeTypesForView];

          this.storeTypesForView = combinedArray.filter((item, index, self) =>
              index === self.findIndex((t) => (
                t.value === item.value
              ))
          );
        }
        else {
          this.storeTypesForView = this.storeTypes;
          NotifierComponent.notify(new Notification('Something went wrong...', NotificationType.DANGER));
        }
        this._cdr.detectChanges();
      });
  }

  public backToPreviousStep(): void {
    this.back.emit();
  }

  private backToPreviousPage(): void {
    this.router.navigate(['/setup']);
  }

  public proceedToNextQuestion(): void {
/*    const categoryTypeArray = this._filteredCategories.filter(category =>
      category?.name?.toLowerCase() === this.selectedStoreType?.toLowerCase() ||
      category?.title?.toLowerCase() === this.selectedStoreType?.toLowerCase() ||
      category?.value?.toLowerCase() === this.selectedStoreType?.toLowerCase());
    if (categoryTypeArray?.length) {
      this.categoryType.emit(categoryTypeArray[0].type);
    }*/
    this.categoryType.emit('ecommerce');
    this.storeTypeSelected.emit({
      type: this.selectedStoreType,
      group: this.selectedBusinessCategory,
    });
  }

}
